import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { BusinessReportEditorProvider } from '../services/store/Report';
import { LoopProvider } from '../services/store/Loop';
import { MappingPropertyProvider } from '../services/store/Mapping';
import { SpreadProvider } from '../services/store/Spread';
import { EntityMetaContextProvider } from '../services/store/EntityMeta';

/**
 * ページ間で共有させたくない（ページ遷移でリセットされる）contextのProviderはここに置く
 */
export function ProviderResetBoundary({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  const location = useLocation();

  return (
    <div key={location.key}>
      <EntityMetaContextProvider>
        <BusinessReportEditorProvider>
          <MappingPropertyProvider>
            <LoopProvider>
              <SpreadProvider>{children}</SpreadProvider>
            </LoopProvider>
          </MappingPropertyProvider>
        </BusinessReportEditorProvider>
      </EntityMetaContextProvider>
    </div>
  );
}
